import React, { useEffect, useState, useMemo } from "react";
import { apiUrl, getApiUrl } from "../../config/config";
import { useHandleActionItem } from "../../hooks/useHandleActionItem";
import { useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import "./TableBody.css"; // Importa el archivo CSS
import Swal from "sweetalert2";

const Toast = Swal.mixin({
	toast: true,
	position: "top-end",
	showConfirmButton: false,
	timer: 3000,
	timerProgressBar: true,
	didOpen: (toast) => {
		toast.onmouseenter = Swal.stopTimer;
		toast.onmouseleave = Swal.resumeTimer;
	},
});

const TableBody = ({ table }) => {
	const navigate = useNavigate();
	const [isLoading, setIsLoading] = useState(true);
	const [data, setData] = useState([]);
	const { handleDelete } = useHandleActionItem();
	const [shouldRefetch, setShouldRefetch] = useState(false);
	const [users, setUsers] = useState();
	const [accounts, setAccounts] = useState();
	const [selectedUser, setSelectedUser] = useState();
	const [selectedAccount, setSelectedAccount] = useState();
	const [startDate, setStartDate] = useState("");
	const [endDate, setEndDate] = useState("");

	// Estados para la paginación
	const [currentPage, setCurrentPage] = useState(0);
	const [itemsPerPage, setItemsPerPage] = useState(20); // Estado para la cantidad de filas por página
	const [searchTerm, setSearchTerm] = useState(""); // Estado para el término de búsqueda

	useEffect(() => {
		fetchData();
		// getUsers();
	}, []);

	useEffect(() => {
		if (shouldRefetch) {
			fetchData();
			setShouldRefetch(false);
		}
	}, [shouldRefetch]);

	useEffect(() => {
		if (data.length > 0) {
			setIsLoading(false);
		}
	}, [data]);

	const handleAddAccounts = (send) => {
		console.log("SEND", `/${table}Details`, send);
		navigate(`/${table}Details`, { state: send });
	};

	const doDelete = (item) => {
		const data = {
			userId: item["ID Usuario"] ? item["ID Usuario"] : "",
			id: item.ID ? item.ID : "",
			accountId: item["ID Cuenta"] ? item["ID Cuenta"] : "",
			amount: item.Monto ? item.Monto : "",
		};

		const res = handleDelete(data, table);
		if (res) {
			setTimeout(() => {
				setShouldRefetch(true);
			}, 1000);
		}
	};

	const fetchData = async () => {
		setIsLoading(true);
		let url = apiUrl;
		const ibAppUrl = await getApiUrl();
		if (ibAppUrl) {
			url = ibAppUrl;
		}

		try {
			const response = await fetch(url + "/getList", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					table: table,
					...(table === "ibUsers" || table === "ibPurchases" ? { userId: JSON.parse(localStorage.getItem("userProfile")).id } : {}),
				}),
			});

			if (response.ok) {
				let data = await response.json();
				console.log("DATA", data);
				if (ibAppUrl) {
					data.data = data;
				}
				data.data.type = "add";

				const excludeKeys = [
					"cardDetails",
					"realToken",
					"demoToken",
					"image",
					"profileImage",
					"actieCustomer",
					"activeDrawings",
					"activeCustomer",
					"businessId",
					"buyTo",
					"bankResponse",
					"invoiceId",
					"address",
					"profit",
					"statusDrawings",
					"drawerName",
					"drawings",
					"deleted",
				];

				const translatedData = data.data.reverse().map((item) => {
					const translatedItem = {};
					for (const key in item) {
						if (excludeKeys.includes(key)) continue;

						let translatedKey;
						switch (key) {
							case "id":
								translatedKey = "ID";
								break;
							case "userId":
								translatedKey = "ID Usuario";
								break;
							case "reservationId":
								translatedKey = "ID Reservación";
								break;
							case "roomId":
								translatedKey = "ID Habitación";
								break;
							case "tableId":
								translatedKey = "ID Mesa";
								break;
							case "totalAmount":
								translatedKey = "Monto Total";
								break;
							case "type":
								translatedKey = "Tipo";
								break;
							case "amount":
								translatedKey = "Monto";
								break;
							case "status":
								translatedKey = "Estado";
								break;
							case "createdAt":
								translatedKey = "Creado";
								break;
							case "time":
								translatedKey = "Tiempo";
								break;
							case "people":
								translatedKey = "Personas";
								break;
							case "notes":
								translatedKey = "Notas";
								break;
							case "source":
								translatedKey = "Fuente";
								break;
							case "checkIn":
								translatedKey = "Check In";
								break;
							case "checkOut":
								translatedKey = "Check Out";
								break;
							case "checkInTime":
								translatedKey = "Hora Entrada";
								break;
							case "checkOutTime":
								translatedKey = "Hora Salida";
								break;
							case "earlyCheckIn":
								translatedKey = "Entrada Temprana";
								break;
							case "lateCheckOut":
								translatedKey = "Salida Tardía";
								break;
							case "reservationCode":
								translatedKey = "Código Reserva";
								break;
							case "selectedExtras":
								translatedKey = "Extras Seleccionados";
								break;
							case "paymentChoice":
								translatedKey = "Método de Pago";
								break;
							case "paymentAddress":
								translatedKey = "Dirección de Pago";
								break;
							case "phone":
								translatedKey = "Teléfono";
								break;
							case "name":
								translatedKey = "Nombre";
								break;
							case "email":
								translatedKey = "Correo";
								break;
							case "currency":
								translatedKey = "Moneda";
								break;
							case "percent":
								translatedKey = "Porcentaje";
								break;
							case "role":
								translatedKey = "Rol";
								break;
							case "commision":
								translatedKey = "Comisión";
								break;
							case "description":
								translatedKey = "Descripción";
								break;
							case "transactionId":
								translatedKey = "ID Transacción";
								break;
							case "transactionHash":
								translatedKey = "Hash Transacción";
								break;
							case "cryptoAddress":
								translatedKey = "Dirección USDT";
								break;
							case "pendingAmount":
								translatedKey = "Pendiente";
								break;
							case "address":
								translatedKey = "Dirección";
								break;
							case "addressFrom":
								translatedKey = "Dirección Origen";
								break;
							case "addressTo":
								translatedKey = "Dirección Destino";
								break;
							case "paymentStatus":
								translatedKey = "Estado Pago";
								break;
							case "paymentGateway":
								translatedKey = "Pasarela de Pago";
								break;
							case "expireAt":
								translatedKey = "Expira";
								break;
							case "password":
								translatedKey = "Admin";
								break;
							case "admin":
								translatedKey = "Administrador";
								break;
							case "roomNumber":
								translatedKey = "Número de Habitación";
								break;
							case "capacity":
								translatedKey = "Capacidad";
								break;
							case "price":
								translatedKey = "Precio";
								break;
							case "bedType":
								translatedKey = "Tipo de Cama";
								break;
							case "imageUrl":
								translatedKey = "URL de Imagen";
								break;
							case "amenities":
								translatedKey = "Comodidades";
								break;
							case "floor":
								translatedKey = "Piso";
								break;
							case "hasBalcony":
								translatedKey = "Balcón";
								break;
							case "hasOceanView":
								translatedKey = "Vista al Mar";
								break;
							default:
								translatedKey = key;
						}

						translatedItem[translatedKey] = item[key];
					}
					return translatedItem;
				});

				setData(translatedData);
				setIsLoading(false);
			} else {
				console.error("Error al registrar:", response.status, response.statusText);
				setIsLoading(false);
			}
		} catch (error) {
			console.error("Error al realizar la solicitud:", error);
			setIsLoading(false);
		}
	};

	const getUsers = async () => {
		setIsLoading(true);
		try {
			const response = await fetch(apiUrl + "/getList", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ table: "users" }),
			});
			if (response.ok) {
				let data = await response.json();
				console.log("USERS:", data);
				setUsers(data.data);
			}
		} catch (error) {
			console.error("Error al realizar la solicitud:", error);
		}
	};

	const formatAccounts = (accData, userId) => {
		return [
			{
				id: accData.realAcc,
				type: "real",
				token: accData.realToken,
				userId: userId,
			},
			{
				id: accData.demoAcc,
				type: "demo",
				token: accData.demoToken,
				userId: userId,
			},
		];
	};

	const getAccounts = async (e) => {
		const userId = e.target.value;

		try {
			const response = await fetch(apiUrl + "/getList", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ table: "accounts", userId }),
			});

			if (response.ok) {
				const result = await response.json();
				const data = result.data;

				// Convertimos el objeto en un array compatible
				const formattedAccounts = formatAccounts(data, userId);
				setAccounts(formattedAccounts);
			}
		} catch (error) {
			console.error("Error al obtener cuentas:", error);
		}
	};

	const getPositions = async (e) => {
		e.preventDefault();
		const accountId = e.target.value;
		setIsLoading(true);
		if (accountId) {
			try {
				const response = await fetch(apiUrl + "/getList2", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({ table: "positions", accountId: accountId }),
				});
				if (response.ok) {
					let data = await response.json();
					console.log("POSITIONS:", data);
					setData(data);
				}
			} catch (error) {
				console.error("Error al realizar la solicitud:", error);
			}
		}
		setIsLoading(false);
	};

	// Manejar el cambio de página
	const handlePageClick = (event) => {
		setCurrentPage(event.selected);
	};

	// Manejar el cambio de cantidad de filas por página
	const handleItemsPerPageChange = (event) => {
		setItemsPerPage(Number(event.target.value));
		setCurrentPage(0); // Reiniciar a la primera página
	};

	const handleCreateIb = async (item) => {
		try {
			const data = {
				userId: item.ID,
				name: item.Nombre,
				email: item.Correo,
			};
			const response = await fetch(apiUrl + "/createIb", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(data),
			});
			console.log("IB created successfully:", response.data);
			Toast.fire({
				icon: "success",
				title: "IB Creado satisfactoriamente",
				background: "#1e2836",
			});
		} catch (error) {
			console.error("Error creating IB:", error);
		}
	};

	const filteredData = data.filter((item) => {
		if (table === "positionsHistory") {
			const userFilter = selectedUser ? String(item["userID"]) === String(selectedUser) : true;
			const accountFilter = selectedAccount ? String(item["accountID"]) === String(selectedAccount) : true;
			const searchFilter = Object.entries(item).some(
				([key, val]) => key !== "Creado" && String(val).toLowerCase().includes(searchTerm.toLowerCase())
			);
			return userFilter && accountFilter && searchFilter;
		}

		// Filtro general
		return Object.entries(item).some(([key, val]) => key !== "Creado" && String(val).toLowerCase().includes(searchTerm.toLowerCase()));
	});

	const offset = currentPage * itemsPerPage;
	const currentPageData = filteredData.slice(offset, offset + itemsPerPage);
	const pageCount = Math.ceil(filteredData.length / itemsPerPage);

	return (
		<div>
			<div className="table-responsive">
				<div className="input-group mb-4">
					<div className="flex-fill position-relative">
						<div className="input-group">
							<span className="input-group-text">
								<i className="fa fa-search"></i>
							</span>
							<input
								type="text"
								className="form-control ps-35px"
								placeholder="Buscar"
								value={searchTerm}
								onChange={(e) => setSearchTerm(e.target.value)}
							/>
						</div>
					</div>
				</div>

				{table === "positionsHistory" && (
					<div>
						<div className="input-group mb-4">
							<div className="flex-fill position-relative me-2">
								<div className="input-group">
									<span className="input-group-text">
										<i className="fa fa-user"></i>
									</span>
									<select
										className="form-control ps-35px"
										value={selectedUser}
										onChange={(e) => {
											setSelectedUser(e.target.value);
											getAccounts(e);
										}}>
										<option value="">Todos los usuarios</option>
										{users &&
											users.length > 0 &&
											users.map((user) => (
												<option key={user.id} value={user.id}>
													{user.id} - {user.name} - {user.email}
												</option>
											))}
									</select>
								</div>
							</div>
							<div className="flex-fill position-relative">
								<div className="input-group">
									<span className="input-group-text">
										<i className="fa fa-briefcase"></i>
									</span>
									<select
										className="form-control ps-35px"
										value={selectedAccount ? selectedAccount.id : ""}
										onChange={(e) => {
											setSelectedAccount(e.target.value);
											console.log("ACCOUNTTTTTT:", e.target.value);
										}}>
										<option value="">Todas las cuentas</option>
										{accounts &&
											accounts.length > 0 &&
											accounts.map((account) => (
												<option key={account.id} value={account.id}>
													{account.id} - {account.type}
												</option>
											))}
									</select>
								</div>
							</div>
						</div>
						<div className="d-flex gap-3 mt-3 mb-4">
							<div className="input-group">
								<span className="input-group-text">
									<i className="fa fa-calendar"></i>
								</span>
								<input type="date" className="form-control" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
							</div>
							<div className="input-group">
								<span className="input-group-text">
									<i className="fa fa-calendar"></i>
								</span>
								<input type="date" className="form-control" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
							</div>
						</div>
					</div>
				)}

				<div className="d-flex justify-content-between align-items-center mb-3">
					<div>
						<label htmlFor="itemsPerPage">Filas por página:</label>
						<select id="itemsPerPage" value={itemsPerPage} onChange={handleItemsPerPageChange}>
							<option value={10}>10</option>
							<option value={20}>20</option>
							<option value={50}>50</option>
							<option value={100}>100</option>
						</select>
					</div>
				</div>
				{data.length === 0 && !isLoading && (
					<div className="text-center">
						<h1>No se encuentran datos</h1>
					</div>
				)}
				{data.length === 0 && isLoading && (
					<div className="text-center">
						<div className="spinner-border text-primary" role="status">
							<span className="visually-hidden">Cargando...</span>
						</div>
					</div>
				)}
				{data.length > 0 && (
					<>
						<table className="table table-hover text-nowrap">
							<thead>
								<tr>
									{Object.keys(currentPageData[0] || {}).map((key, i) => (
										<th key={i} className="align-middle">
											{key}
										</th>
									))}
									<th className="pt-0 pb-2">Acción</th>
								</tr>
							</thead>
							{currentPageData.map((item, index) => (
								<tbody key={index}>
									<tr>
										{Object.entries(item).map(([key, value], i) => (
											<td className="align-middle" key={i}>
												{key === "Estado"
													? typeof value === "string" && value === "1"
														? "🟢"
														: typeof value === "string" && value === "0"
														? "🔴"
														: value
													: key === "Rol"
													? value === "customer"
														? "Cliente"
														: value
													: key === "Creado"
													? new Date(value).toLocaleString().replace("T", " ").replace("Z", "")
													: key === "Expira"
													? new Date(value).toLocaleString().replace("T", " ").replace("Z", "")
													: key === "Contraseña"
													? "********"
													: key === "Administrador"
													? value === 1
														? "🟢"
														: value === 0
														? "🔴"
														: ""
													: value}
											</td>
										))}
										<td className="align-middle">
											{(table !== "accounts" || table !== "positionHistory") && (
												<>
													<button
														onClick={() => handleAddAccounts({ type: "edit", data: item })}
														className="btn btn-outline-primary btn-sm mr-3"
														style={{ marginRight: "0.75rem" }}>
														<i className="fa fa-edit"></i>
													</button>
													<button onClick={() => doDelete(item)} className="btn btn-outline-danger btn-sm">
														<i className="fa fa-trash"></i>
													</button>
												</>
											)}
										</td>
									</tr>
								</tbody>
							))}
						</table>
						<ReactPaginate
							previousLabel={<i className="fa fa-chevron-left"></i>}
							nextLabel={<i className="fa fa-chevron-right"></i>}
							pageCount={pageCount}
							onPageChange={handlePageClick}
							containerClassName={"pagination"}
							previousLinkClassName={"pagination__link"}
							nextLinkClassName={"pagination__link"}
							disabledClassName={"pagination__link--disabled"}
							activeClassName={"pagination__link--active"}
							pageClassName={"pagination__page"}
							breakClassName={"pagination__break"}
						/>
					</>
				)}
			</div>
		</div>
	);
};

export default TableBody;
